import React from "react";
import { Menu, MenuButton, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import AccountSettings from "./Actions/UserSettings";
import { FaUserCircle } from "react-icons/fa";

const UserActionsDropdown = ({ user, logout, onClickActions }) => {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <MenuButton className="flex w-33 justify-center gap-x-1.5 rounded-xl text-white px-3 py-2 text-sm font-semibold bg-[#44485c] ">
        <span className="flex items-center gap-2">
          <FaUserCircle size={18} />
          {user?.username || "Guest"}
        </span>
        <span>
          <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
        </span>
      </MenuButton>
      <MenuItems className="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-primary-dark shadow-lg  focus:outline-none">
        <AccountSettings user={user} logout={logout} onClickActions={onClickActions} />
      </MenuItems>
    </Menu>
  );
};

export default UserActionsDropdown;
